import LayoutNavigation from "../Components/Layout/LayoutNavigation";
import AdminNavigationSection from "./AdminNavigationSection";
import RootNavigationSection from "./RootNavigationSection";

export default () => {
	return (
		<LayoutNavigation>
			<AdminNavigationSection />
			<RootNavigationSection />
		</LayoutNavigation>
	);
};
